import { render, staticRenderFns } from "./TotteBagPopup.vue?vue&type=template&id=7ed01c5a&scoped=true"
import script from "./TotteBagPopup.vue?vue&type=script&lang=js"
export * from "./TotteBagPopup.vue?vue&type=script&lang=js"
import style0 from "./TotteBagPopup.vue?vue&type=style&index=0&id=7ed01c5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed01c5a",
  null
  
)

export default component.exports